document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".js-tabButton"),
        contents = document.querySelectorAll(".js-tabContent");

  if (tabs.length > 0) {
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {

        tabs.forEach(t => t.classList.remove("is-active"));
        contents.forEach(c => c.classList.remove("is-active"));

        tab.classList.add("is-active");

        if (contents[index]) {
          contents[index].classList.add("is-active");
        }

        // ▼ XJ Highchartsの再描画
        setTimeout(function () {
          if (window.Highcharts && Highcharts.charts) {
            Highcharts.charts.forEach(function (chart) {
              if (chart && typeof chart.reflow === "function") {
                chart.reflow();
              }
            });
          }

          window.dispatchEvent(new Event("resize"));
        }, 200);

      });
    });
  }

  const modalOpenButtons = document.querySelectorAll(".js-modalOpen"),
        modalContent = document.querySelector(".js-modalContent"),
        overlay = document.querySelector(".js-overlay");

  if (modalOpenButtons.length > 0 && modalContent && overlay) {
    modalOpenButtons.forEach(button => {
      button.addEventListener("click", () => {
        modalContent.classList.add("is-active");
        overlay.classList.add("is-active");
      });
    });

    [...document.querySelectorAll(".js-modalClose"), overlay].forEach(element => {
      if (element) {
        element.addEventListener("click", () => {
          modalContent.classList.remove("is-active");
          overlay.classList.remove("is-active");
        });
      }
    });
  }

  const circleContainer = document.getElementById("js-circle");

  if (circleContainer) {
    const circleBar = document.getElementById("js-circle-bar"),
          circleText = document.getElementById("js-circle-text"),
          val = parseFloat(circleContainer.dataset.value),
          color = circleContainer.dataset.color,
          circ = 2 * Math.PI * 45;

    if (circleBar) {
      circleBar.style.stroke = color;
      circleBar.style.strokeDasharray = circ;
      circleBar.style.strokeDashoffset = circ;

      setTimeout(() => {
        circleBar.style.strokeDashoffset = circ - val / 100 * circ;

        if (circleText) {
          circleText.textContent = val;
        }
      }, 100);
    }
  }

  const bars = document.querySelectorAll(".js-bar");

  if (bars.length > 0) {
    bars.forEach(bar => {
      const bVal = bar.dataset.value,
            bColor = bar.dataset.color,
            fill = bar.querySelector(".bar-fill"),
            text = bar.querySelector(".js-val");

      if (fill && text) {
        fill.style.backgroundColor = bColor;
        text.textContent = bVal + "%";

        setTimeout(() => {
          fill.style.width = bVal + "%";
        }, 200);
      }
    });
  }

  const select = document.getElementById("year-filter");

  if (select) {
    const sections = document.querySelectorAll(".js-target-section");

    select.addEventListener("change", event => {
      const selectedValue = event.target.value;

      sections.forEach(section => {
        if (selectedValue === "all" || section.dataset.year === selectedValue) {
          section.classList.add("is-show");
        } else {
          section.classList.remove("is-show");
        }
      });
    });

    select.dispatchEvent(new Event("change"));
  }

  const chartTable = document.querySelector('[data-js="chart-table"]'),
        chartCanvas = document.querySelector('[data-js="ownership-chart"]');

  if (chartTable && chartCanvas) {

    const labelElements = chartTable.querySelectorAll("[data-chart-label]"),
          valueElements = chartTable.querySelectorAll("[data-chart-value]");

    const labels = Array.from(labelElements).map(el => el.textContent.trim());

    const dataValues = Array.from(valueElements).map(el =>
      parseFloat(el.textContent.replace(/,/g, ""))
    );

    const colors = [
      "#BD9FC8",
      "#5F70B2",
      "#F3A080",
      "#A5CE7A",
      "#F2A4B1",
      "#73C6EE"
    ];

    if (typeof Chart !== "undefined") {
      new Chart(chartCanvas, {
        type: "doughnut",
        data: {
          labels,
          datasets: [{
            data: dataValues,
            backgroundColor: colors,
            borderWidth: 0
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          cutout: "55%",
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: true
            }
          }
        }
      });
    }
  }

});